import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  ColumnTitle,
  dateRender,
  IconApp,
  Modal,
  Pagination,
  ScrollbarCustom,
  WrapTable,
} from "../../";
import { useGetListAuditLogByType } from "../../../services/auditLog";
import { useState } from "react";
import { getDiffObject, toTitleCase } from "../../../utils/format";

export const ModalAuditLog = (props: {
  open: boolean;
  onClose: () => void;
  params: {
    type?: string;
    action?: string;
    id?: string;
  };
}) => {
  const [page, setPage] = useState(1);
  const { data, isFetching } = useGetListAuditLogByType({
    page,
    ...props.params,
  });

  return (
    <Modal
      {...props}
      name="Audit log"
      description="View & edit your charge point’s pricing"
      icon={<IconApp width={"27px"} name={"History"} />}
    >
      <Box display={"flex"} flexDirection="column" gap={2}>
        <Box display={"flex"} flexDirection="column" gap={1}>
          <WrapTable isLoading={isFetching} height="100%">
            <TableContainer>
              <ScrollbarCustom autoHide autoHeightMax={"50vh"}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <ColumnTitle sx={{ minWidth: 50 }} align="center">
                        SN
                      </ColumnTitle>
                      <ColumnTitle sx={{ minWidth: 50 }} align="center">
                        Activities
                      </ColumnTitle>
                      <ColumnTitle>User</ColumnTitle>
                      <ColumnTitle>Email</ColumnTitle>
                      {/* <ColumnTitle>
                        CPO/SP
                      </ColumnTitle> */}
                      <ColumnTitle>Date</ColumnTitle>
                      <ColumnTitle>Detail</ColumnTitle>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.data.map((row: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {page * 10 - 10 + index + 1}
                        </TableCell>
                        <TableCell sx={{ minWidth: 250 }} align="center">
                          {/* {row.action} */}
                          {toTitleCase(row.where)}
                        </TableCell>
                        <TableCell>{row.Admin?.name}</TableCell>
                        <TableCell>{row.Admin?.email}</TableCell>
                        {/* <TableCell>
                          {row.CPO?.name} <br></br> {row.SP?.name}
                        </TableCell> */}
                        <TableCell>
                          {dateRender(row.created_at)}
                        </TableCell>
                        <TableCell>
                          {getDiffObject(row.old_payload, row.new_payload).map(
                            (diff, index) => (
                              <div key={index}>{diff}</div>
                            ),
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </ScrollbarCustom>
            </TableContainer>
          </WrapTable>
          <Pagination
            page={page}
            setPage={setPage}
            totalItems={data?.total || 0}
            totalPage={Math.ceil((data?.total || 0) / 10)}
            currentPage={page}
          />
        </Box>
        <Button
          fullWidth
          size="large"
          variant="contained"
          onClick={props.onClose}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};
